import pubsub from "../../pubsub";
import * as ko from "knockout";
import {IRectCss} from "./index";
import highlightHtml from './highlight.html?raw';

export let template = highlightHtml;

interface IParams {
    id: string
}

export class viewModel {
    public rect: KnockoutObservable<IRectCss | null> = ko.observable(null);

    constructor(private params: IParams) {
        pubsub.trigger('viewModel.initialized', {id: params.id, vm: this});
    }

    private getStyle(): any {
        const rect = this.rect();
        if (!rect) {
            return null;
        }
        const {top, left, width, height} = rect;
        return {top, left, width, height};
    }

}
